// JsFromRoutes CacheKey f600c12d99303b4a780d6b6d347e0123
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/profile'),
  update: /* #__PURE__ */ definePathHelper('patch', '/profile'),
  updatePassword: /* #__PURE__ */ definePathHelper('patch', '/profile/password'),
  updateStatus: /* #__PURE__ */ definePathHelper('patch', '/profile/status'),
  updateAutoAway: /* #__PURE__ */ definePathHelper('patch', '/profile/auto-away'),
  heartbeat: /* #__PURE__ */ definePathHelper('post', '/profile/heartbeat'),
  updateDigests: /* #__PURE__ */ definePathHelper('patch', '/profile/digests'),
  sendSampleDigest: /* #__PURE__ */ definePathHelper('post', '/profile/digests/sample'),
  disconnectIdentity: /* #__PURE__ */ definePathHelper('delete', '/profile/identity/:id'),
}
